import React, { useEffect, useState } from "react";
import EAModal from "../Modal/EAModal";
import EAAlert from "../EAAlert";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_GUS_CUSTOMER } from "../../../api/apiRoutes";
import "./GusImportModal.scss";

export interface GusCustomerData {
  name: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  postCode: string;
  locality: string;
}

interface IProps {
  nip: string;
  onClose: () => void;
  onAccept: (data: GusCustomerData) => void;
}

const FIELDS: { label: string; key: keyof GusCustomerData }[] = [
  { label: "Nazwa firmy", key: "name" },
  { label: "Ulica", key: "street" },
  { label: "Numer budynku", key: "houseNumber" },
  { label: "Numer mieszkania", key: "flatNumber" },
  { label: "Kod pocztowy", key: "postCode" },
  { label: "Miejscowość", key: "locality" },
];

const GusImportModal: React.FC<IProps> = ({ nip, onClose, onAccept }) => {
  const facilityIds = useFacility();
  const { get: apiGet } = useApiRequest();
  const [loading, setLoading] = useState(true);
  const [errorTable, setErrorTable] = useState<string[]>([]);
  const [data, setData] = useState<GusCustomerData | null>(null);

  useEffect(() => {
    const fetchGusData = async () => {
      const { isError, errorTable: errors, result } = await apiGet(GET_GUS_CUSTOMER(facilityIds, nip));
      if (!isError) {
        if (result?.name) {
          setData(result);
        } else {
          setErrorTable(["Nie znaleziono firmy dla podanego numeru NIP."]);
        }
      } else {
        setErrorTable(errors ?? []);
      }
      setLoading(false);
    };
    fetchGusData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isError = errorTable.length > 0;

  return (
    <EAModal
      isOpen
      onClose={onClose}
      title="Dane z rejestru GUS"
      loading={loading}
      acceptButtonLabel="Wypełnij formularz"
      cancelButtonLabel="Anuluj"
      hideAcceptButton={isError}
      onAccept={() => data && onAccept(data)}
    >
      <div className="gus-import-modal__content">
        {!isError && data && (
          <p className="gus-import-modal__description">
            Poniżej znajdziesz dane pobrane z rejestru GUS. Sprawdź ich poprawność, a następnie kliknij{" "}
            <strong>Wypełnij formularz</strong>, aby automatycznie uzupełnić pola faktury.
          </p>
        )}
        {isError && <EAAlert type="error" messages={errorTable} />}
        {data && (
          <div className="gus-import-modal__data">
            {FIELDS.filter(({ key }) => !!data[key]).map(({ label, key }) => (
              <React.Fragment key={key}>
                <span className="gus-import-modal__label">{label}</span>
                <span className="gus-import-modal__value">{data[key]}</span>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </EAModal>
  );
};

export default GusImportModal;
